<template>
  <Layout>
    <PageHeader :items="items" :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                     <span v-for="(err, index) in validation_errors" :key="index">{{ err[0] }} <br/></span>
                </div>
                <form>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label for="batch_id">Batch <span class="c-required">*</span></label>
                      <select v-model="exam.batch_id" v-validate="'required'" id="batch_id" name="batch_id" class="form-control form-control-sm">
                        <option :value="''">Select Batch</option>
                        <option v-for="(batch, index) in batches" :key="index" :value="batch.id">{{ batch.trade.desc }} | Batch No : {{ batch.batch_no }}</option>
                      </select>
                      <div class="invalid-feedback">Please Select Batch</div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="batch_id">Exam Type<span class="c-required">*</span></label>
                      <select v-model="exam.exam_type_id" v-validate="'required'" id="exam_type_id" name="exam_type_id" class="form-control form-control-sm">
                        <option :value="''">Select Exam Type</option>
                        <option v-for="(examType, index) in examTypes" :key="index" :value="examType.id">{{ examType.desc }}</option>
                      </select>
                      <div class="invalid-feedback">Please Select Exam Type</div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="title">Exam Title<span class="c-required">*</span></label>
                      <input type="text" v-model="exam.title" v-validate="{ required: true }" class="form-control form-control-sm" id="title" name="title" placeholder="Title"/>
                      <div class="invalid-feedback">Please enter exam title.</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="date">Date <span class="c-required">*</span></label>
                      <datepicker id="date" v-model="exam.date" v-validate="'required'" :format="customDate" name="date" placeholder="Date"></datepicker>
                      <div v-if="errors.has('date')" class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;">Date required</div>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="description">Description</label>
                      <textarea v-model="exam.description" class="form-control form-control-sm" rows="1" id="description" name="description" placeholder="Description"></textarea>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <button class="btn btn-success waves-effect waves-light mr-2" @click.prevent="save">Save</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Create Exam",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, Datepicker},
  data() {
    return {
      title: "Create Exam",
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Batch',
          href: '/batch/list',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
      exam: {
        batch_id: "",
        title: "",
        date: "",
        description: "",
        exam_type_id : ""
      },
      batches: [],
      examTypes : [],
      validation_errors: {},
      show: false,
    };
  },

  mounted() {
    this.getBatch();
  },

  methods: {
    getBatch() {
      http
          .get("api/exam/codes")
          .then(response => {
            this.batches = response.data.batches;
            this.examTypes = response.data.examTypes
          })
          .catch();
    },
    customDate(date) {
      this.exam.date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.post("api/exams", this.exam)
              .then(response => {
                console.log(response.data)
                if (!response.data.error) {
                  if (response.data.permissionError) {
                    this.$bvToast.toast(response.data.permissionError, {
                      title: "Error",
                      autoHideDelay: 5000,
                      variant: "danger"
                    });
                  } else {
                    this.$bvToast.toast(response.data.message, {
                      title: "Success",
                      autoHideDelay: 5000,
                      variant: "success"
                    });
                    this.resetForm()
                  }
                } else {
                  this.$bvToast.toast(response.data.message, {
                    title: "Error",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    resetForm() {
      this.exam.batch_id = ''
      this.exam.title = ''
      this.exam.date = ''
      this.exam.description = ''
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    }
  },

  computed: {
    userPermission () {
      return this.$store.state.user
    }
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>

<style lang="scss">
.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}
</style>
